import { FieldsEnum, RenewalChangedAddressEnum } from 'app/shared/enums';
import { zipCodeChange } from 'app/services/businessFunctions/helpers/zipCodeChange';
import { addRenewalChangedAddress } from 'app/shared/helpers/addRenewalChangedAddress';

const secondCoownerAddressDetails = {
  coowners2LegalAddressZipCodeChange(initialRun: boolean) {
    addRenewalChangedAddress(
      initialRun,
      RenewalChangedAddressEnum.Coowner2Legal
    );

    zipCodeChange(initialRun, FieldsEnum.Coowners2LegalAddressZipCode);
  },

  coowners2LegalAddressCityChange(initialRun: boolean) {
    addRenewalChangedAddress(
      initialRun,
      RenewalChangedAddressEnum.Coowner2Legal
    );
  },
};

export default secondCoownerAddressDetails;
